import { useEffect, useState } from "react";
import api from "@/api";

const fmt = (n) => Number(n || 0).toLocaleString(undefined, { maximumFractionDigits: 6 });
const dt = (s) => new Date(s).toLocaleString();

const TYPES = ["all", "deposit", "roi", "referral", "invest", "withdrawal", "principal_return", "adjustment"];
const typeColor = {
  deposit: "text-emerald-400", roi: "text-sky-400", referral: "text-amber-400",
  invest: "text-slate-300", withdrawal: "text-red-400", principal_return: "text-emerald-300",
  adjustment: "text-purple-400",
};

export default function History() {
  const [filter, setFilter] = useState("all");
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get(`/transactions?type=${filter}`).then(({ data }) => setRows(data.transactions));
  }, [filter]);

  return (
    <div>
      <h1 className="text-2xl sm:text-3xl font-bold mb-1">Ledger & History</h1>
      <p className="text-sm text-slate-400 mb-6">All your transactions — deposits, ROI, referral and withdrawals.</p>

      <div className="flex flex-wrap gap-2 mb-6">
        {TYPES.map((t) => (
          <button key={t} data-testid={`filter-${t}`} onClick={() => setFilter(t)}
            className={`px-4 py-2 rounded-full text-xs font-medium capitalize ${filter === t ? "bg-emerald-500 text-white" : "bg-white/5 text-slate-400 hover:text-white"}`}>
            {t.replace("_", " ")}
          </button>
        ))}
      </div>

      <div className="card-surface rounded-2xl overflow-hidden">
        {rows.length === 0 ? (
          <div className="p-8 text-center text-slate-500" data-testid="no-transactions">No transactions found.</div>
        ) : (
          <div className="divide-y divide-border">
            {rows.map((r) => (
              <div key={r.id} className="flex items-center justify-between p-4" data-testid={`tx-${r.id}`}>
                <div>
                  <div className={`font-semibold capitalize ${typeColor[r.type] || "text-white"}`}>{r.type.replace("_", " ")}</div>
                  <div className="text-xs text-slate-500">{dt(r.created_at)} {r.network ? `· ${r.network}` : ""}</div>
                  {r.tx_hash && <div className="text-xs text-slate-500 break-all font-mono">{r.tx_hash}</div>}
                </div>
                <div className="text-right">
                  <div className={`font-mono font-semibold ${typeColor[r.type] || "text-white"}`}>
                    {["withdrawal", "invest"].includes(r.type) ? "-" : "+"}${fmt(r.amount)}
                  </div>
                  <div className={`text-xs ${r.status === "completed" ? "text-emerald-400" : r.status === "rejected" ? "text-red-400" : "text-amber-400"}`}>{r.status}</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
